var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container download-discount-block"},[_c('button',{staticClass:"button",on:{"click":function($event){$event.preventDefault();return _vm.downloadDiscountFile()}}},[_vm._v(_vm._s(_vm.$t('download_discount')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }